var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('v-img',_vm._b({attrs:{"src":_vm.src,"contain":""}},'v-img',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }